import React from 'react';
import "./Products.scss";
import {motion} from "framer-motion";
import Accordion from "../../components/Accordion/Accordion";
import servicesData from "./servicesData";

function Products() {
    return (
        <motion.div
            className="products"
            initial={{width: 0}}
            animate={{width: "100%"}}
            exit={{x: window.innerWidth, transition: {duration: 0.3}}}
        >
            <div className="container">
                <div className="container-top">
                    <Accordion items={servicesData}/>
                </div>
            </div>
        </motion.div>
    );
}

export default Products;